export enum CheckoutMethodsEnum {
  cashAppBitcoin = 'cashapp_bitcoin',
  paypalPYUSD = 'paypal_pyusd'
}
